import React, { useState } from 'react';
import {
  Alert,
  AlertTitle,
  Button, Dialog, DialogContent, DialogTitle, Stack, Switch, Typography,
} from '@mui/material';
import { FormDialogActions, useApiClient } from '@marageti/z4-lib';
import { Partner, PartnerProfileUpdate } from '@marageti/z4-sdk/lib/travel/Partner';
import { enqueueSnackbar } from 'notistack';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';

type Props = {
  partner: Partner,
  value: boolean,
  open: boolean,
  handleClose: () => void,
  handleSubmit: (value: boolean) => void,
};

const EditPartnerPRL = ({
  partner, value, open, handleClose, handleSubmit,
}: Props) => {
  const [optInStatus, setOptInStatus] = useState(value);
  const [submissionError, setSubmissionError] = useState<ApiError>();
  const apiClient = useApiClient();

  const handleSubmitButtonClick = async () => {
    if (!partner) return;

    const updatedPartnerProfile: PartnerProfileUpdate = {
      id: partner.id,
      capacity: partner.capacity,
      notes: partner.notes,
      partnerReferralProgram: optInStatus,
    };

    try {
      await apiClient.partnersClient.putPartnerProfile(partner.id, updatedPartnerProfile);
      handleSubmit(optInStatus);
      enqueueSnackbar('Profile updated.', { variant: 'success' });
    } catch (error) {
      setSubmissionError(error as ApiError);
      enqueueSnackbar('An error occurred during the update.', { variant: 'default' });
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="edit-prl-dialog" aria-describedby="alert-dialog-description" fullWidth maxWidth="xs">
      <DialogTitle id="edit-prl-dialog">
        Edit PRL Program Opt-In
      </DialogTitle>
      <DialogContent>
        {submissionError && (
        <Alert severity="error">
          <AlertTitle>
            There was a problem updating the partner PRL Status
          </AlertTitle>
          {submissionError.message}
          {submissionError.code && `Code: ${submissionError.code} `}
          {submissionError.id && `ID: ${submissionError.id}`}
        </Alert>
        )}
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="body" color="#000">Opt into PRL Program?</Typography>
          <Switch
            color="primary"
            checked={optInStatus}
            id="partnerReferralProgram"
            onClick={() => setOptInStatus(!optInStatus)}
          />
        </Stack>
      </DialogContent>
      <FormDialogActions>
        <Button onClick={handleSubmitButtonClick} variant="contained" fullWidth>
          Submit
        </Button>
        <Button onClick={handleClose} variant="outlined" fullWidth>Cancel</Button>
      </FormDialogActions>
    </Dialog>
  );
};
export default EditPartnerPRL;
